/* --- Desplazamiento con respaldo ----------------------------------------
   Safari no acepto la forma con objeto de `scrollTo` / `scrollIntoView` hasta
   la 15.4: en versiones anteriores la llamada se ignora y no pasa nada. Se
   comprueba el soporte una vez y, si falta, se usa la forma antigua: salta en
   seco, pero llega, que es lo que importa. */
var SUAVE_OK = 'scrollBehavior' in document.documentElement.style;

function irA(caja, izquierda) {
  if (SUAVE_OK) caja.scrollTo({ left: izquierda, behavior: 'smooth' });
  else caja.scrollLeft = izquierda;
}

function verElemento(el, bloque) {
  if (SUAVE_OK) { el.scrollIntoView({ behavior: 'smooth', block: bloque }); return; }
  var r = el.getBoundingClientRect();
  var y = r.top + window.pageYOffset;
  if (bloque === 'center') y -= (window.innerHeight - r.height) / 2;
  window.scrollTo(0, Math.max(0, y));
}

/* Strapion storefront behavior */
(function () {
  'use strict';

  function bindProductZoomBackdrop() {
    document.querySelectorAll('dialog.dialog-zoomed-gallery__dialog').forEach(function (dialog) {
      if (dialog.dataset.strapionBackdropClose) return;
      dialog.dataset.strapionBackdropClose = '1';
      var startedOnBackdrop = false;
      dialog.addEventListener('mousedown', function (event) {
        startedOnBackdrop = event.target === dialog;
      });
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog && startedOnBackdrop) dialog.close();
        startedOnBackdrop = false;
      });
    });
  }

  function bindRevealMotion() {
    var items = document.querySelectorAll('.s-reveal:not([data-reveal-bound])');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (item) { item.classList.add('s-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries, instance) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('s-visible');
        instance.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    items.forEach(function (item) {
      item.dataset.revealBound = '1';

      /* Lo que ya esta en la primera pantalla se muestra YA, sin observador y
         sin animacion. Animar la entrada de algo que el visitante ya tiene
         delante no aporta nada, y dejaba la pagina en manos de cuando decida
         disparar el IntersectionObserver.

         En iOS aparecia la cabecera de cada bloque pero las fotos salian en
         blanco hasta que rascabas un poco: el observador no llegaba a marcar
         esas tarjetas en la primera pintada. En Chrome si lo hacia, por eso no
         se reproducia aqui. Con esta comprobacion deja de depender de eso. */
      if (item.getBoundingClientRect().top < window.innerHeight) {
        item.classList.add('s-visible');
        return;
      }

      observer.observe(item);
    });
  }

  function updateHeaderState() {
    document.body.classList.toggle('s-scrolled', window.scrollY > 24);
  }

  function bindMobileMenu() {
    document.querySelectorAll('.sh-mobile-menu:not([data-menu-bound])').forEach(function (menu) {
      menu.dataset.menuBound = '1';
      menu.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function () { menu.removeAttribute('open'); });
      });
      document.addEventListener('click', function (event) {
        if (menu.open && !menu.contains(event.target)) menu.removeAttribute('open');
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') menu.removeAttribute('open');
      });
    });
  }

  /* Contador del carrito en la cabecera.
     El marcado lo pinta Liquid una sola vez, asi que sin esto el numero se
     queda congelado hasta recargar la pagina. */

  function setCartCount(count) {
    document.querySelectorAll('[data-cart-link]').forEach(function (link) {
      var bubble = link.querySelector('[data-cart-bubble]');
      if (!bubble) return;

      var previo = bubble.textContent.trim();
      link.setAttribute('aria-label', 'Cart, ' + count + ' items');
      bubble.textContent = count;

      if (count > 0) {
        bubble.removeAttribute('hidden');
      } else {
        bubble.setAttribute('hidden', '');
      }

      if (count > 0 && String(count) !== previo) {
        bubble.classList.remove('is-bumped');
        void bubble.offsetWidth; // fuerza un reflow para poder repetir la animacion
        bubble.classList.add('is-bumped');
      }
    });
  }

  function refreshCartCount() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) { setCartCount(cart.item_count); })
      .catch(function () { /* si falla, el numero se queda como estaba */ });
  }

  function bindCartCount() {
    if (document.documentElement.dataset.cartCountBound) return;
    document.documentElement.dataset.cartCountBound = '1';

    // Lo dispara el tema al anadir, quitar o cambiar cantidades.
    document.addEventListener('shopify:cart:lines-update', function (event) {
      if (!event || !event.promise) {
        refreshCartCount();
        return;
      }

      event.promise.then(function (resultado) {
        var detail = resultado && resultado.detail;

        // Si la peticion fallo, dejamos el numero anterior en vez de mentir.
        if (detail && detail.didError) return;

        // El evento trae un carrito, pero con las claves de Storefront y
        // `detail.itemCount` son las unidades anadidas, no el total. Pedimos
        // /cart.js, que es la fuente inequivoca del total.
        refreshCartCount();
      }, refreshCartCount);
    });

    // Al volver con el boton atras el navegador restaura el HTML antiguo.
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) refreshCartCount();
    });
  }

  /* Anticipo del configurador en la home.
     Cambia la foto al elegir color y actualiza el enlace para que el
     configurador abra en ese mismo color. Aqui no hay variantes ni precios:
     eso es cosa del configurador de verdad. */
  function bindHomeBuilder() {
    var swatches = document.querySelector('[data-hb-swatches]');
    if (!swatches || swatches.dataset.builderBound) return;
    swatches.dataset.builderBound = '1';

    var imagen = document.querySelector('[data-hb-imagen]');
    var etiqueta = document.querySelector('[data-hb-etiqueta]');
    var enlace = document.querySelector('[data-hb-enlace]');
    if (!imagen || !enlace) return;

    var base = enlace.getAttribute('href').split('?')[0];

    // Traerse las fotos por adelantado: sin esto el primer clic de cada color
    // parpadea mientras se descarga.
    window.setTimeout(function () {
      swatches.querySelectorAll('[data-hb-foto]').forEach(function (boton) {
        var previa = new Image();
        previa.src = boton.dataset.hbFoto;
      });
    }, 1200);

    swatches.addEventListener('click', function (evento) {
      var boton = evento.target.closest('[data-hb-color]');
      if (!boton || boton.classList.contains('is-activo')) return;

      swatches.querySelectorAll('[data-hb-color]').forEach(function (otro) {
        otro.classList.toggle('is-activo', otro === boton);
        otro.setAttribute('aria-checked', otro === boton ? 'true' : 'false');
      });

      imagen.classList.add('is-cambiando');
      var nueva = new Image();
      nueva.onload = nueva.onerror = function () {
        imagen.src = boton.dataset.hbFoto;
        imagen.alt = boton.dataset.hbNombre;
        // Reflow forzado, no requestAnimationFrame: en una pestana en segundo
        // plano rAF no corre y la foto se quedaria transparente.
        void imagen.offsetWidth;
        imagen.classList.remove('is-cambiando');
      };
      nueva.src = boton.dataset.hbFoto;

      if (etiqueta) etiqueta.textContent = boton.dataset.hbNombre;
      enlace.href = base + '?color=' + encodeURIComponent(boton.dataset.hbColor);
    });

    // Flechas dentro del grupo, como espera un radiogroup.
    swatches.addEventListener('keydown', function (evento) {
      if (evento.key !== 'ArrowLeft' && evento.key !== 'ArrowRight') return;
      var botones = Array.prototype.slice.call(swatches.querySelectorAll('[role="radio"]'));
      var i = botones.indexOf(evento.target);
      if (i < 0) return;
      evento.preventDefault();
      var siguiente = botones[(i + (evento.key === 'ArrowRight' ? 1 : botones.length - 1)) % botones.length];
      siguiente.click();
      siguiente.focus();
    });
  }

  /* Carrusel de correas de la home.
     El desplazamiento lo hace el navegador; esto solo pone flechas y puntos
     encima. Las paginas se calculan del ancho real, asi que el mismo codigo
     vale para 4, 2 o 1 tarjeta por vista sin saber nada de los cortes. */
  function bindCarousels() {
    document.querySelectorAll('[data-carrusel]:not([data-carrusel-bound])').forEach(function (raiz) {
      raiz.dataset.carruselBound = '1';

      var track = raiz.querySelector('[data-carrusel-track]');
      var nav = raiz.querySelector('[data-carrusel-nav]');
      var contenedorPuntos = raiz.querySelector('[data-carrusel-dots]');
      var anterior = raiz.querySelector('[data-carrusel-prev]');
      var siguiente = raiz.querySelector('[data-carrusel-next]');
      if (!track || !nav) return;

      function paginas() {
        return Math.max(1, Math.round(track.scrollWidth / track.clientWidth));
      }

      function paginaActual() {
        return Math.round(track.scrollLeft / track.clientWidth);
      }

      function pintarPuntos() {
        var total = paginas();

        if (total < 2) {
          nav.hidden = true;
          return;
        }
        nav.hidden = false;

        if (contenedorPuntos.children.length !== total) {
          contenedorPuntos.innerHTML = '';
          for (var i = 0; i < total; i++) {
            var punto = document.createElement('button');
            punto.type = 'button';
            punto.className = 's-carousel__dot';
            punto.setAttribute('role', 'tab');
            punto.setAttribute('aria-label', 'Page ' + (i + 1) + ' of ' + total);
            punto.dataset.pagina = String(i);
            contenedorPuntos.appendChild(punto);
          }
        }

        var actual = paginaActual();
        Array.prototype.forEach.call(contenedorPuntos.children, function (punto, i) {
          punto.classList.toggle('is-activo', i === actual);
          punto.setAttribute('aria-selected', i === actual ? 'true' : 'false');
        });

        // Un margen de 2px: el scroll no siempre cae en el pixel exacto.
        anterior.disabled = track.scrollLeft <= 2;
        siguiente.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      }

      function irA(pagina) {
        irA(track, pagina * track.clientWidth);
      }

      anterior.addEventListener('click', function () { irA(paginaActual() - 1); });
      siguiente.addEventListener('click', function () { irA(paginaActual() + 1); });

      contenedorPuntos.addEventListener('click', function (evento) {
        var punto = evento.target.closest('[data-pagina]');
        if (punto) irA(Number(punto.dataset.pagina));
      });

      var pendiente;
      track.addEventListener('scroll', function () {
        window.clearTimeout(pendiente);
        pendiente = window.setTimeout(pintarPuntos, 90);
      }, { passive: true });

      window.addEventListener('resize', function () {
        window.clearTimeout(pendiente);
        pendiente = window.setTimeout(pintarPuntos, 160);
      });

      pintarPuntos();
    });
  }

  /* Aviso de reposicion: mete la variante elegida en el correo.
     El selector de variantes cambia sin recargar, asi que el valor correcto
     solo se sabe en el momento de enviar. `product-form-component` mantiene un
     input oculto llamado "id" con la variante actual: esa es la fuente. */
  function bindRestockVariant() {
    document.querySelectorAll('[data-sr-aviso]:not([data-sr-bound])').forEach(function (caja) {
      caja.dataset.srBound = '1';

      var form = caja.querySelector('form');
      var campoVariante = caja.querySelector('[data-sr-variante]');
      var campoCuerpo = caja.querySelector('[data-sr-cuerpo]');
      if (!form || !campoVariante || !campoCuerpo) return;

      var ids, titulos;
      try {
        ids = JSON.parse(caja.dataset.srVariantes);
        titulos = JSON.parse(caja.dataset.srTitulos);
      } catch (e) {
        return;
      }

      form.addEventListener('submit', function () {
        var actual = document.querySelector('input[name="id"]');
        if (!actual) return;

        var i = ids.indexOf(Number(actual.value));
        if (i < 0) return;

        campoVariante.value = titulos[i];
        campoCuerpo.value = 'RESTOCK::' + caja.dataset.srHandle + ' · ' + titulos[i];
      });
    });
  }

  /* Resenas: abrir el formulario y bajar suave al bloque desde las estrellas
     del titulo, como en Amazon. */
  function bindReviews() {
    document.querySelectorAll('[data-sr-abrir]:not([data-sr-abrir-bound])').forEach(function (boton) {
      boton.dataset.srAbrirBound = '1';
      boton.addEventListener('click', function () {
        var caja = document.querySelector('[data-sr-caja]');
        if (!caja) return;
        caja.classList.remove('is-plegada');
        caja.classList.add('is-abierta');
        var primer = caja.querySelector('input, textarea');
        verElemento(caja, 'center');
        if (primer) window.setTimeout(function () { primer.focus(); }, 400);
      });
    });

    document.querySelectorAll('[data-sr-saltar]:not([data-sr-saltar-bound])').forEach(function (enlace) {
      enlace.dataset.srSaltarBound = '1';
      enlace.addEventListener('click', function (evento) {
        var destino = document.getElementById('resenas');
        if (!destino) return;
        evento.preventDefault();
        verElemento(destino, 'start');
      });
    });

    // Si el formulario se envio, Shopify recarga con el ancla: hay que
    // desplegarlo para que se vea el mensaje de gracias.
    var caja = document.querySelector('[data-sr-caja]');
    if (caja && caja.querySelector('.sr-form__ok, .sr-form__error')) {
      caja.classList.remove('is-plegada');
      caja.classList.add('is-abierta');
    }
  }

  function boot() {
    bindProductZoomBackdrop();
    bindRevealMotion();
    bindMobileMenu();
    bindCartCount();
    bindHomeBuilder();
    bindCarousels();
    bindRestockVariant();
    bindReviews();
    updateHeaderState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('scroll', updateHeaderState, { passive: true });
  new MutationObserver(function () {
    bindProductZoomBackdrop();
    bindRevealMotion();
    bindMobileMenu();
    bindHomeBuilder();
    bindCarousels();
    bindRestockVariant();
    bindReviews();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();


/* El selector de familias se ancla arriba en movil cuando el de la cabecera
   sale de pantalla. Con IntersectionObserver y no con scroll: no hay que medir
   nada en cada fotograma y aguanta cualquier alto de cabecera. */
(function () {
  'use strict';

  var barra = document.querySelector('[data-sx-switch-fijo]');
  if (!barra || !window.IntersectionObserver) return;

  // El original es el primero que no vive dentro de la propia barra.
  var original = null;
  var todos = document.querySelectorAll('.sx-switch');
  for (var i = 0; i < todos.length; i++) {
    if (!todos[i].closest('[data-sx-switch-fijo]')) { original = todos[i]; break; }
  }
  if (!original) return;

  new IntersectionObserver(function (entradas) {
    var fuera = !entradas[0].isIntersecting;
    barra.classList.toggle('is-fijo', fuera);
    barra.setAttribute('aria-hidden', fuera ? 'false' : 'true');
  }, { threshold: 0 }).observe(original);
})();


/* Los adelantos de familia muestran sus colorways solos, y tambien al pulsar
   una muestra. Las dos cosas pintan lo mismo, asi que comparten funcion.
   Las muestras siguen siendo enlaces: sin JS llevan igualmente a su destino. */
(function () {
  'use strict';

  var INTERVALO = 3200;
  var quieto = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var SALIDA = 190;

  /* Relevo entre dos fotos. Se precarga la nueva antes de tocar nada: si se
     cambia el src en seco, el hueco se queda vacio mientras descarga y el
     relevo se convierte en un parpadeo. */
  function cambiarFoto(foto, src, alt) {
    /* Fuera el srcset: si se queda, el navegador sigue eligiendo de la lista
       vieja y la foto no cambia. */
    foto.removeAttribute('srcset');
    foto.removeAttribute('sizes');

    function poner() {
      foto.src = src;
      if (alt) foto.alt = alt;
    }

    if (quieto) { poner(); return; }

    var previa = new Image();
    previa.onload = previa.onerror = function () {
      foto.classList.add('sx-sale');

      window.setTimeout(function () {
        poner();
        foto.classList.remove('sx-sale');

        // Estado de entrada sin transicion, reflow, y ya anima hasta su sitio.
        foto.classList.add('sx-entra');
        void foto.offsetWidth;
        foto.classList.remove('sx-entra');
      }, SALIDA);
    };
    previa.src = src;
  }

  /** Lleva la tarjeta de una caja al colorway de esa muestra. */
  function aplicarVista(caja, muestra) {
    var foto = caja.querySelector('.s-product-card__image img');
    var titulo = caja.querySelector('.s-product-card__meta h3 a');
    var precio = caja.querySelector('.s-product-card__meta strong');
    if (!foto || !titulo) return;

    var src = muestra.getAttribute('data-img');
    if (src && foto.getAttribute('src') !== src) {
      cambiarFoto(foto, src, muestra.getAttribute('data-titulo'));
    }

    titulo.textContent = muestra.getAttribute('data-titulo') || titulo.textContent;
    if (precio && muestra.getAttribute('data-precio')) {
      precio.textContent = muestra.getAttribute('data-precio');
    }

    // La tarjeta pasa a apuntar al colorway que se esta viendo.
    var destino = muestra.getAttribute('href');
    if (destino) {
      var enlaces = caja.querySelectorAll('.s-product-card__image, .s-product-card__meta h3 a');
      Array.prototype.forEach.call(enlaces, function (a) { a.setAttribute('href', destino); });
    }

    var hermanas = caja.querySelectorAll('[data-sx-vista]');
    Array.prototype.forEach.call(hermanas, function (m) { m.classList.remove('is-activa'); });
    muestra.classList.add('is-activa');
  }

  /* --- clic: manda el visitante ---------------------------------------- */

  document.addEventListener('click', function (evento) {
    var muestra = evento.target.closest && evento.target.closest('[data-sx-vista]');
    if (!muestra) return;

    var caja = muestra.closest('.sc-familia__caja');
    if (!caja) return;

    evento.preventDefault();

    // Si ha elegido a mano, el giro automatico se calla y no le lleva la contraria.
    if (caja.sxDetener) caja.sxDetener();
    aplicarVista(caja, muestra);
  });

  /* --- giro automatico -------------------------------------------------- */

  function girar(caja) {
    /* Solo giran los colorways. Los adelantos por diseno (miniaturas) se
       quedan quietos: ahi cada foto es un producto distinto y no una version
       del mismo, asi que el cambio automatico se lee como que la tarjeta se
       equivoca de producto, no como un colorway girando. */
    if (caja.querySelector('.sc-familia__mini')) return;

    var muestras = Array.prototype.slice.call(caja.querySelectorAll('[data-sx-vista]'));
    if (muestras.length < 2) return;

    var i = 0;
    var reloj = null;
    var ala_vista = false;
    var detenido = false;

    function paso() {
      i = (i + 1) % muestras.length;
      aplicarVista(caja, muestras[i]);
    }

    function arrancar() {
      if (reloj || detenido || document.hidden) return;
      reloj = window.setInterval(paso, INTERVALO);
    }

    function parar() {
      if (!reloj) return;
      window.clearInterval(reloj);
      reloj = null;
    }

    caja.sxDetener = function () { detenido = true; parar(); };

    /* Solo gira lo que se esta viendo: fuera de pantalla no aporta nada y
       deja al navegador descargando fotos que nadie mira. */
    if (window.IntersectionObserver) {
      new IntersectionObserver(function (entradas) {
        ala_vista = entradas[0].isIntersecting;
        if (ala_vista) arrancar(); else parar();
      }, { threshold: 0.35 }).observe(caja);
    } else {
      ala_vista = true;
      arrancar();
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) parar(); else if (ala_vista) arrancar();
    });

    // Con el raton encima se para: quien mira una foto no quiere que se le vaya.
    caja.addEventListener('mouseenter', parar);
    caja.addEventListener('mouseleave', function () { if (ala_vista) arrancar(); });
  }

  if (!quieto) {
    Array.prototype.forEach.call(document.querySelectorAll('.sc-familia__caja'), girar);
  }
})();


/* --- Barra de compra fija en movil --------------------------------------
   El configurador es una columna larga: foto, color, frame, cantidad y solo
   entonces el precio. En movil eso son 2,6 pantallas antes de saber cuanto
   cuesta. La barra no duplica logica: refleja el precio que ya calcula el
   configurador y su boton pulsa el de verdad, asi que packs, validaciones y
   avisos siguen pasando por el mismo sitio. */
(function () {
  'use strict';

  // El del modal de compra rapida no cuenta: ahi no se hace scroll de pagina.
  var botones = document.querySelectorAll('[data-sx-add]');
  var real = null;
  for (var i = 0; i < botones.length; i++) {
    if (!botones[i].closest('.quick-add-modal, dialog')) { real = botones[i]; break; }
  }
  if (!real) return;

  var panel = real.closest('[data-configurador]') || document;
  var precio = panel.querySelector('[data-sx-precio]');
  if (!precio) return;

  var valorColor = panel.querySelector('[data-sx-valor="design"]') || panel.querySelector('[data-sx-valor="color"]');
  var valorFrame = panel.querySelector('[data-sx-valor="model"]');

  var barra = document.createElement('div');
  barra.className = 'sx-barra';
  barra.innerHTML =
    '<div class="sx-barra__datos">' +
      '<strong class="sx-barra__precio"></strong>' +
      '<span class="sx-barra__resumen"></span>' +
    '</div>' +
    '<button type="button" class="sx-barra__boton"></button>';
  document.body.appendChild(barra);

  var elPrecio = barra.querySelector('.sx-barra__precio');
  var elResumen = barra.querySelector('.sx-barra__resumen');
  var elBoton = barra.querySelector('.sx-barra__boton');

  function refrescar() {
    elPrecio.textContent = precio.textContent.trim();
    elBoton.textContent = real.textContent.trim();
    elBoton.disabled = real.disabled;

    var partes = [];
    if (valorColor && valorColor.textContent.trim()) partes.push(valorColor.textContent.trim());
    if (valorFrame && valorFrame.textContent.trim()) partes.push(valorFrame.textContent.trim());
    elResumen.textContent = partes.join(' · ');
  }

  refrescar();

  /* Se escucha el panel en vez de recalcular: cualquier cosa que cambie el
     precio —color, frame, tramo, mezcla— pasa por ahi. */
  if (window.MutationObserver) {
    new MutationObserver(refrescar).observe(panel, {
      subtree: true, childList: true, characterData: true, attributes: true,
      attributeFilter: ['disabled', 'class']
    });
  }

  elBoton.addEventListener('click', function () {
    real.click();
  });

  /* Solo aparece cuando el boton de verdad no se ve: teniendolo delante, la
     barra seria un segundo boton compitiendo con el mismo. */
  if (window.IntersectionObserver) {
    new IntersectionObserver(function (entradas) {
      barra.classList.toggle('is-visible', !entradas[0].isIntersecting);
    }, { threshold: 0 }).observe(real);
  }
})();


/* La zona fijada tiene un solo tamano. Hubo una version que la encogia al
   pasar el selector de frames, y se quito: cambiar de alto mueve el contenido,
   y ese movimiento es lo que decide si hay que cambiar de alto, asi que el
   estado se disparaba en bucle. Con scroll real, continuo y con inercia, ni la
   histeresis ni la compensacion lo evitaban. */


/* --- Carrito: barra de pack, agrupacion, titulos y precio unico ----------
   Cuatro arreglos sobre el carrito nativo de Horizon, sin tocar sus plantillas.

   Funciona a la vez en la PAGINA `/cart` y en el CAJON lateral, porque los dos
   pintan el mismo snippet y comparten contenedor: `.cart-items__wrapper`. Se
   recorren todos los que haya en el documento, no uno solo — con el cajon
   abierto sobre la pagina del carrito existen los dos.

   El cajon es lo que de verdad ve el cliente: al anadir desde el configurador
   se abre encima, y ahi es donde se decide si sigue hasta la caja.

   1. El descuento de pack solo aparecia cuando YA estaba ganado, como una
      linea dentro del subtotal. Con una unidad nadie sabia que anadiendo otra
      se lleva un 10%. Ahora hay una barra que dice a cuanto estas del tramo.
   2. Las correas de un pack se leen como un lote, no como productos sueltos
      que casualmente llevan descuento.
   3. El titulo trae el sufijo "— Nylon for WHOOP 5.0" en las 42 referencias.
   4. Con cantidad 1 el precio salia dos veces con el mismo numero. */
(function () {
  'use strict';

  var pendiente = false;

  function dinero(centavos) {
    return '$' + (centavos / 100).toFixed(2);
  }

  /* Una sola regla para todo el sufijo: vale para "— Nylon for WHOOP 5.0",
     "— Breathable Nylon...", "— Special Edition..." y "— Leather...". */
  function acortar(t) {
    return t
      .replace(/\s*[—–-]\s*[^—–-]*for\s+WHOOP\s*5\.0\s*$/i, '')
      .replace(/^Strapion\s+/i, '');
  }

  function limpiarTitulos() {
    var sitios = '.cart-items__title,' +
      ' product-card a.user-select-text .text-block p,' +
      ' product-card .product-grid-view-zoom-out--details h3';

    document.querySelectorAll(sitios).forEach(function (a) {
      if (a.dataset.sxCorto) return;
      var t = (a.textContent || '').trim();
      var corto = acortar(t);
      if (!corto || corto === t) return;
      if (!a.getAttribute('aria-label')) a.setAttribute('aria-label', t);
      a.textContent = corto;
      a.dataset.sxCorto = '1';
    });
  }

  /* El precio de linea ya esta en la columna de la derecha. El unitario solo
     aporta algo cuando hay mas de una unidad de esa linea. */
  function precioUnico() {
    document.querySelectorAll('.cart-items__table-row').forEach(function (fila) {
      // La primera fila es la cabecera de la tabla, sin precio ni cantidad.
      if (!fila.querySelector('.cart-items__unit-price-wrapper')) return;
      var campo = fila.querySelector('input[name="updates[]"], .quantity-selector input');
      var cant = campo ? Number(campo.value || campo.getAttribute('value') || 1) : 1;
      fila.classList.toggle('sx-linea--una', cant <= 1);
    });
  }

  function textoDe(cant, ahorro) {
    if (cant >= 3) {
      return {
        titulo: 'Trio pack unlocked — 15% off',
        pie: ahorro > 0 ? 'You are saving ' + dinero(ahorro) : 'Biggest discount applied.'
      };
    }
    if (cant === 2) {
      return {
        titulo: 'Duo pack unlocked — 10% off',
        pie: 'Add 1 more band and save 15% instead.'
      };
    }
    return {
      titulo: 'Add 1 more band — save 10%',
      pie: 'Any band counts — nylon, prints or leather.'
    };
  }

  function pintarBarra(envoltorio, cant, ahorro) {
    var caja = envoltorio.previousElementSibling;
    if (!caja || !caja.classList.contains('sx-pack')) {
      caja = document.createElement('div');
      caja.className = 'sx-pack';
      envoltorio.parentNode.insertBefore(caja, envoltorio);
    }

    var t = textoDe(cant, ahorro);
    var hechos = Math.min(cant, 3);

    var pasos = '';
    for (var i = 1; i <= 3; i++) {
      pasos += '<span class="sx-pack__paso' + (i <= hechos ? ' is-hecho' : '') + '">' + i + '</span>';
    }

    caja.className = 'sx-pack' + (cant >= 3 ? ' sx-pack--tope' : '') + (cant >= 2 ? ' sx-pack--activo' : '');
    caja.innerHTML =
      '<div class="sx-pack__cab">' +
        '<strong class="sx-pack__titulo">' + t.titulo + '</strong>' +
        (ahorro > 0 ? '<span class="sx-pack__ahorro">−' + dinero(ahorro) + '</span>' : '') +
      '</div>' +
      '<div class="sx-pack__barra"><i style="width:' + (hechos / 3 * 100) + '%"></i></div>' +
      '<div class="sx-pack__pasos">' + pasos + '</div>' +
      '<p class="sx-pack__pie">' + t.pie + '</p>';
  }

  function agrupar(envoltorio, cant, ahorro) {
    var tramo = null;
    if (cant >= 3) tramo = 'Trio pack';
    else if (cant === 2) tramo = 'Duo pack';

    var tira = envoltorio.querySelector('.sx-grupo');

    if (!tramo) {
      envoltorio.classList.remove('is-pack');
      if (tira) tira.remove();
      return;
    }

    envoltorio.classList.add('is-pack');

    if (!tira) {
      tira = document.createElement('div');
      tira.className = 'sx-grupo';
      envoltorio.insertBefore(tira, envoltorio.firstChild);
    }

    tira.innerHTML =
      '<span class="sx-grupo__nombre">' + tramo + '</span>' +
      '<span class="sx-grupo__detalle">' + cant + ' bands together</span>' +
      (ahorro > 0 ? '<span class="sx-grupo__ahorro">−' + dinero(ahorro) + '</span>' : '');
  }

  function pintar(carrito) {
    var cant = carrito.item_count;
    var ahorro = carrito.original_total_price - carrito.total_price;

    /* Puede haber dos a la vez: el de la pagina y el del cajon abierto encima. */
    document.querySelectorAll('.cart-items__wrapper').forEach(function (envoltorio) {
      var barra = envoltorio.previousElementSibling;

      if (!cant) {
        if (barra && barra.classList.contains('sx-pack')) barra.remove();
        envoltorio.classList.remove('is-pack');
        var t = envoltorio.querySelector('.sx-grupo');
        if (t) t.remove();
        return;
      }

      pintarBarra(envoltorio, cant, ahorro);
      agrupar(envoltorio, cant, ahorro);
    });
  }

  function refrescar() {
    if (pendiente) return;
    pendiente = true;

    window.requestAnimationFrame(function () {
      pendiente = false;
      limpiarTitulos();
      precioUnico();

      window.fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(pintar)
        .catch(function () { /* sin red, la pagina sigue siendo usable */ });
    });
  }

  /* Horizon rehace la lista al cambiar una cantidad, y el cajon se reemplaza
     de golpe al anadir, asi que no valen los oyentes sobre botones concretos.
     Se vigila el documento y se ignora lo que cambia dentro de lo que pinta
     este mismo modulo, que si no se realimenta. */
  new MutationObserver(function (cambios) {
    for (var i = 0; i < cambios.length; i++) {
      var n = cambios[i].target;
      if (n.nodeType === 1 && (n.closest('.sx-pack') || n.closest('.sx-grupo'))) continue;
      refrescar();
      return;
    }
  }).observe(document.body, { childList: true, subtree: true });

  document.addEventListener('shopify:cart:lines-update', refrescar);

  refrescar();
})();


/* === Pack cruzado de la ficha ============================================
   Ensena "esta correa + una de nylon" justo debajo del boton de comprar, con
   un selector para cambiar la segunda.

   Por que existe: el pedido mas rentable de la tienda es cuero + nylon y esa
   combinacion solo se sugeria en "You may also like", a 4.283 px medidos del
   boton de comprar. Aqui cae a 150 px.

   Decisiones que conviene no deshacer sin saber por que estan:

   - La pareja por defecto sale del PRIMER grupo (Solid). Un liso combina con
     el cuero mejor que un estampado, que compite con el por atencion.
   - Dentro del grupo gana la mejor surtida en esa montura, no la primera.
     Con "la primera" salia Green Camo, que solo conserva Gold y Rose Gold: el
     bloque habria ensenado Black y Silver tachados pegados al boton.
   - Las pestanas FILTRAN el carrusel en vez de desplazarlo. Con 31 lisos mas
     estampados y deporte, un carrusel unico obliga a barrer decenas de
     miniaturas para llegar a la que se busca.
   - En el carrusel las correas sin stock en esa montura NO se pintan; en los
     cierres si se pintan tachadas. No es incoherente: de correas hay decenas
     y esconder una no engana a nadie, mientras que esconder un cierre haria
     creer que esa montura no existe, con MG Black y MG Silver a cero en todo
     el catalogo.
   - El cierre se pregunta y no se deduce: el cuero solo dice "Whoop 5" o "MG"
     porque lleva hebilla propia de acero, mientras que en el nylon la montura
     y el color del cierre son la misma opcion ("Whoop 5 Black"). */
(function () {
  'use strict';

  var SELECTOR_CAJON = '[on\\:click="#cart-drawer/toggle"]';

  /* El automatico de la tienda: -10% desde 2 unidades. El bloque siempre anade
     1 + 1, asi que este es el tramo que le toca. Si cambia en el panel de
     Shopify hay que cambiarlo aqui: el bloque solo ANUNCIA el descuento. */
  var PCT_PACK = 10;

  /* Negro y plata son las monturas mas comunes de WHOOP: se ofrecen primero
     cuando hay stock. */
  var ORDEN_CIERRE = ['Black', 'Silver', 'Gold', 'Rose Gold'];

  function dinero(centimos) {
    return '$' + (centimos / 100).toFixed(2);
  }

  /* Encaje entre la montura elegida en la ficha y la de otro producto.

     Los dos catalogos no describen la montura igual: el cuero dice "Whoop 5"
     o "MG" —lleva hebilla propia de acero— y el nylon dice "Whoop 5 Black",
     metiendo familia y color de cierre en el mismo valor. Por eso la
     comparacion va en los dos sentidos:

       cuero -> nylon : "Whoop 5" contra "Whoop 5 Black", el otro es mas
                        concreto y lo que sobra es el cierre a elegir.
       nylon -> cuero : "Whoop 5 Black" contra "Whoop 5", el otro es mas
                        general y encaja sin preguntar nada.
       nylon -> nylon : iguales, encaje exacto.

     El espacio del prefijo no es cosmetico: sin el, "MG" encajaria con
     monturas que solo empiezan por esas letras.

     Vive aqui arriba y no dentro del bundle porque la usan dos cosas: el
     bundle y el filtro de "You may also like". Con una copia en cada sitio,
     cambiar una y olvidar la otra daria dos criterios distintos en la misma
     pagina. */
  function encaja(frame, montura) {
    if (!frame || !montura) return false;
    if (frame === montura) return true;
    if (frame.indexOf(montura + ' ') === 0) return true;
    if (montura.indexOf(frame + ' ') === 0) return true;
    return false;
  }

  function monturaActual() {
    var panel = document.querySelector('[data-configurador]');
    return (panel && panel.dataset.sxMontura) || '';
  }

  function iniciar(caja) {
    if (caja.sxPackListo) return;
    caja.sxPackListo = true;

    var bloque = caja.querySelector('[data-sx-cruzado-datos]');
    if (!bloque) return;

    var datos;
    try {
      datos = JSON.parse(bloque.textContent);
    } catch (e) {
      return;
    }
    var productos = (datos && datos.productos) || {};
    var grupos = (datos && datos.grupos) || [];
    var propias = (datos && datos.propias) || {};
    var propiaDefecto = (datos && datos.propiaDefecto) || '';
    if (!grupos.length) return;

    /* Del panel de compra salen la variante y la montura elegidas: el
       configurador las publica en su propio nodo en cada repintado. */
    var panel = caja.parentNode.querySelector('[data-configurador]');
    if (!panel) return;

    /* El envoltorio sin clase del bloque custom_liquid es item de un flex de
       Horizon y con min-width:auto crecia hasta el max-content del carrusel.
       No tiene clase a la que agarrarse desde CSS, asi que se le pone aqui. */
    caja.parentNode.classList.add('sx-cruzado-host');

    var el = {
      fotoA: caja.querySelector('[data-sx-cruzado-foto-a]'),
      foto: caja.querySelector('[data-sx-cruzado-foto]'),
      enlace: caja.querySelector('[data-sx-cruzado-enlace]'),
      nombre: caja.querySelector('[data-sx-cruzado-nombre]'),
      precioA: caja.querySelector('[data-sx-cruzado-precio-a]'),
      precioB: caja.querySelector('[data-sx-cruzado-precio-b]'),
      cambiar: caja.querySelector('[data-sx-cruzado-cambiar]'),
      selector: caja.querySelector('[data-sx-cruzado-selector]'),
      pestanas: caja.querySelector('[data-sx-cruzado-pestanas]'),
      carrusel: caja.querySelector('[data-sx-cruzado-carrusel]'),
      chips: caja.querySelector('[data-sx-cruzado-chips]'),
      filaCierres: caja.querySelector('[data-sx-cruzado-cierres-fila]'),
      etiquetaCierres: caja.querySelector('[data-sx-cruzado-cierres-label]'),
      antes: caja.querySelector('[data-sx-cruzado-antes]'),
      ahora: caja.querySelector('[data-sx-cruzado-ahora]'),
      off: caja.querySelector('[data-sx-cruzado-off]'),
      add: caja.querySelector('[data-sx-cruzado-add]'),
      aviso: caja.querySelector('[data-sx-cruzado-feedback]')
    };

    var estado = {
      handle: null,     // pareja elegida a mano; null = la automatica
      cierre: null,
      montura: null,
      grupo: 0,
      abierto: false
    };

    /* Ultima lista de grupos con existencias. `estado.grupo` indexa ESTA, no
       la cruda: un grupo sin nada en la montura elegida no se pinta y los
       indices se desplazarian. */
    var ultimosGrupos = [];

    /* Lo que aun hay que elegir de la candidata. Si tiene un eje propio
       —el color del cuero— manda ese; si no, el trozo de montura que la
       candidata concreta y la ficha no. Cuando no sobra nada, devuelve null
       y la fila de opciones se esconde. */
    function opcionDe(v, producto, montura) {
      if (producto.etiquetaExtra && v.extra) return v.extra;
      if (v.frame && v.frame.indexOf(montura + ' ') === 0) {
        return v.frame.slice(montura.length + 1);
      }
      return null;
    }

    function cierresDe(producto, montura) {
      var vistos = {};
      var fuera = [];
      producto.variantes.forEach(function (v) {
        if (!encaja(v.frame, montura)) return;
        var c = opcionDe(v, producto, montura);
        var clave = c === null ? '\u0000' : c;
        if (vistos[clave]) return;
        vistos[clave] = true;
        fuera.push({ nombre: c, variante: v });
      });
      fuera.sort(function (a, b) {
        var ia = ORDEN_CIERRE.indexOf(a.nombre);
        var ib = ORDEN_CIERRE.indexOf(b.nombre);
        return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib);
      });
      return fuera;
    }

    function cuantosCierres(producto, montura) {
      var vistos = {};
      producto.variantes.forEach(function (v) {
        if (!v.disponible || !encaja(v.frame, montura)) return;
        var c = opcionDe(v, producto, montura);
        vistos[c === null ? '\u0000' : c] = true;
      });
      return Object.keys(vistos).length;
    }

    /* Handles de un grupo que tienen algo que vender en esa montura. */
    function vivosDe(grupo, montura) {
      return grupo.handles.filter(function (h) {
        var pr = productos[h];
        return pr && cuantosCierres(pr, montura) > 0;
      });
    }

    /* Pareja por defecto: la PRIMERA del primer grupo que ofrezca al menos dos
       cierres en esa montura.

       Antes se cogia la mejor surtida a secas, y con el orden nuevo eso
       dejaba la foto en una correa apagada mientras el carrusel abria en
       amarillo: el bloque se contradecia a si mismo. Se respeta el orden,
       pero con un minimo de dos cierres para no repetir el caso Green Camo
       —una correa con una sola variante viva pegada al boton de comprar—.
       Si ninguna llega a dos, se cae a la mejor surtida antes que esconder
       el bloque. */
    function parejaAutomatica(montura) {
      for (var g = 0; g < grupos.length; g++) {
        var vivos = vivosDe(grupos[g], montura);
        for (var i = 0; i < vivos.length; i++) {
          if (cuantosCierres(productos[vivos[i]], montura) >= 2) return vivos[i];
        }
        var mejor = null;
        var cuenta = 0;
        for (var j = 0; j < vivos.length; j++) {
          var n = cuantosCierres(productos[vivos[j]], montura);
          if (n > cuenta) { cuenta = n; mejor = vivos[j]; }
        }
        if (mejor) return mejor;
      }
      return null;
    }

    /* El precio unitario no se lee del texto del panel: con Duo o Trio
       marcados ese texto ensena el total del pack, no la unidad. Sale de la
       variante publicada, buscada en los datos del configurador. */
    function unidadActual() {
      var id = Number(panel.dataset.sxVariante || 0);
      if (!id) return null;
      var fuente = panel.parentNode.querySelector('[data-sx-datos]');
      if (!fuente) return null;
      var d;
      try {
        d = JSON.parse(fuente.textContent);
      } catch (e) {
        return null;
      }
      var encontrada = null;
      (d.designs || []).forEach(function (design) {
        (design.variantes || []).forEach(function (v) {
          if (v.id === id) encontrada = v;
        });
      });
      return encontrada;
    }

    /* Foto de la correa de la izquierda. Sale del mapa que emite Liquid, no
       de la galeria del tema: la galeria se repinta con un fetch posterior al
       aviso del configurador, asi que leerla de ahi dejaba la foto del pack
       una seleccion por detras. Medido antes del cambio: a 1.800 ms la
       galeria ya estaba en negro y el pack seguia ensenando la marron. */
    function fotoPropia() {
      var id = panel.dataset.sxVariante || '';
      return propias[id] || propiaDefecto || '';
    }

    function pintarChips(cierres, producto) {
      /* Con una sola posibilidad la fila sobra: en una ficha de nylon la
         montura ya viene entera de arriba y no queda nada que preguntar. */
      var unica = cierres.length < 2 || cierres[0].nombre === null;
      if (el.filaCierres) el.filaCierres.hidden = unica;
      if (el.etiquetaCierres) {
        el.etiquetaCierres.textContent = producto.etiquetaExtra || 'Clasp';
      }
      el.chips.innerHTML = '';
      if (unica) return;
      cierres.forEach(function (c) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'sx-cruzado__chip' + (estado.cierre === c.nombre ? ' is-activo' : '') +
                      (c.variante.disponible ? '' : ' is-agotado');
        b.setAttribute('role', 'radio');
        b.setAttribute('aria-checked', estado.cierre === c.nombre ? 'true' : 'false');
        b.textContent = c.nombre;
        if (!c.variante.disponible) {
          b.disabled = true;
          b.setAttribute('aria-disabled', 'true');
          b.title = 'Currently unavailable';
        }
        b.addEventListener('click', function () {
          estado.cierre = c.nombre;
          pintar();
        });
        el.chips.appendChild(b);
      });
    }

    function pintarPestanas(montura, conGrupos) {
      el.pestanas.innerHTML = '';
      conGrupos.forEach(function (info, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'sx-cruzado__pestana' + (i === estado.grupo ? ' is-activo' : '');
        b.setAttribute('role', 'tab');
        b.setAttribute('aria-selected', i === estado.grupo ? 'true' : 'false');
        b.innerHTML = '<span>' + info.grupo.nombre + '</span><i>' + info.vivos.length + '</i>';
        b.addEventListener('click', function () {
          estado.grupo = i;
          pintarCarrusel(montura, conGrupos);
          /* El carrusel vuelve al principio: quedarse a media tira de la
             familia anterior hace pensar que la pestana no ha hecho nada. */
          el.carrusel.scrollLeft = 0;
        });
        el.pestanas.appendChild(b);
      });
    }

    function pintarCarrusel(montura, conGrupos) {
      Array.prototype.forEach.call(el.pestanas.children, function (b, i) {
        b.className = 'sx-cruzado__pestana' + (i === estado.grupo ? ' is-activo' : '');
        b.setAttribute('aria-selected', i === estado.grupo ? 'true' : 'false');
      });

      var info = conGrupos[estado.grupo];
      el.carrusel.innerHTML = '';
      if (!info) return;

      info.vivos.forEach(function (h) {
        var pr = productos[h];
        var activo = h === (estado.handle || caja.dataset.sxParejaHandle);
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'sx-cruzado__opcion' + (activo ? ' is-activo' : '');
        b.setAttribute('aria-pressed', activo ? 'true' : 'false');
        b.innerHTML =
          '<span class="sx-cruzado__opcion-foto"><img src="' + (pr.foto || '') + '" alt="" loading="lazy" width="72" height="72"></span>' +
          '<span class="sx-cruzado__opcion-nombre"></span>';
        b.querySelector('.sx-cruzado__opcion-nombre').textContent = pr.corto;
        b.addEventListener('click', function () {
          estado.handle = h;
          /* El cierre se reinicia: el que estaba elegido puede no existir en
             la correa nueva y el bloque anunciaria una variante imposible. */
          estado.cierre = null;
          pintar();
        });
        el.carrusel.appendChild(b);
      });
    }

    function pintar() {
      var montura = panel.dataset.sxMontura || '';
      var cambioMontura = montura !== estado.montura;
      estado.montura = montura;

      /* Al cambiar de montura se suelta la eleccion manual si esa correa ya no
         tiene nada que vender ahi. */
      if (cambioMontura && estado.handle) {
        var elegida = productos[estado.handle];
        if (!elegida || cuantosCierres(elegida, montura) === 0) estado.handle = null;
      }

      var conGrupos = [];
      grupos.forEach(function (g) {
        var vivos = vivosDe(g, montura);
        if (vivos.length) conGrupos.push({ grupo: g, vivos: vivos });
      });
      if (!conGrupos.length) { caja.hidden = true; return; }
      ultimosGrupos = conGrupos;
      if (estado.grupo >= conGrupos.length) estado.grupo = 0;

      var handle = estado.handle || parejaAutomatica(montura);
      var pareja = handle ? productos[handle] : null;
      if (!pareja) { caja.hidden = true; return; }

      var cierres = cierresDe(pareja, montura);
      var disponibles = cierres.filter(function (c) { return c.variante.disponible; });
      if (!disponibles.length) { caja.hidden = true; return; }

      /* El cierre marcado puede no existir en la montura nueva o haberse
         quedado sin stock: se cae al primero que si esta. */
      var elegido = null;
      for (var i = 0; i < disponibles.length; i++) {
        if (disponibles[i].nombre === estado.cierre) { elegido = disponibles[i]; break; }
      }
      if (!elegido) { elegido = disponibles[0]; estado.cierre = elegido.nombre; }

      var unidad = unidadActual();
      if (!unidad || !unidad.precio) { caja.hidden = true; return; }

      var bruto = unidad.precio + elegido.variante.precio;
      /* Misma cuenta que Shopify sobre el total del carrito, comprobada contra
         un carrito real: 6.390 con -10% da 5.751 clavado. */
      var neto = bruto - Math.round((bruto * PCT_PACK) / 100);

      var propia = fotoPropia();
      if (el.fotoA && propia && el.fotoA.getAttribute('src') !== propia) {
        el.fotoA.src = propia;
      }
      el.foto.src = pareja.foto || '';
      el.foto.alt = pareja.corto;
      el.enlace.href = pareja.url;
      el.nombre.textContent = pareja.corto;
      el.precioA.textContent = dinero(unidad.precio);
      el.precioB.textContent = dinero(elegido.variante.precio);
      el.antes.textContent = dinero(bruto);
      el.ahora.textContent = dinero(neto);
      el.off.textContent = '-' + PCT_PACK + '%';
      el.off.hidden = false;

      caja.dataset.sxParejaHandle = handle;
      caja.dataset.sxParejaVariante = String(elegido.variante.id);

      pintarChips(cierres, pareja);
      pintarPestanas(montura, conGrupos);
      pintarCarrusel(montura, conGrupos);
      caja.hidden = false;
    }

    el.cambiar.addEventListener('click', function () {
      estado.abierto = !estado.abierto;
      el.selector.hidden = !estado.abierto;
      el.cambiar.setAttribute('aria-expanded', estado.abierto ? 'true' : 'false');
      el.cambiar.classList.toggle('is-abierto', estado.abierto);
      if (estado.abierto) {
        /* Se abre en la familia de la correa que ya esta puesta: abrir siempre
           en la primera obligaba a buscar de nuevo la que estaba elegida. */
        var puesta = caja.dataset.sxParejaHandle;
        /* Se busca en los grupos VISIBLES, que son los que tienen algo en esta
           montura: estado.grupo indexa esa lista, no la cruda. */
        for (var i = 0; i < ultimosGrupos.length; i++) {
          if (ultimosGrupos[i].vivos.indexOf(puesta) >= 0) { estado.grupo = i; break; }
        }
        pintar();
      }
    });

    function avisar(texto, tipo) {
      el.aviso.textContent = texto;
      el.aviso.className = 'sx-cruzado__feedback is-visible' + (tipo ? ' sx-cruzado__feedback--' + tipo : '');
      window.setTimeout(function () {
        el.aviso.className = 'sx-cruzado__feedback';
        el.aviso.textContent = '';
      }, 6000);
    }

    function abrirCajon() {
      var cajon = document.querySelector('theme-drawer#cart-drawer');
      if (cajon && typeof cajon.open === 'function') { cajon.open(); return; }
      var disp = document.querySelector(SELECTOR_CAJON);
      if (disp) disp.click();
    }

    el.add.addEventListener('click', function () {
      var idA = Number(panel.dataset.sxVariante || 0);
      var idB = Number(caja.dataset.sxParejaVariante || 0);
      if (!idA || !idB || el.add.classList.contains('is-cargando')) return;

      el.add.classList.add('is-cargando');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: idA, quantity: 1 }, { id: idB, quantity: 1 }],
          sections: 'cart-drawer-section'
        })
      })
        .then(function (r) {
          return r.json().then(function (cuerpo) {
            if (!r.ok) throw new Error(cuerpo.description || cuerpo.message || 'Could not add to cart');
            return cuerpo;
          });
        })
        .then(function (cuerpo) {
          if (cuerpo.sections && cuerpo.sections['cart-drawer-section']) {
            var destino = document.getElementById('shopify-section-cart-drawer-section');
            if (destino) {
              var env = document.createElement('div');
              env.innerHTML = cuerpo.sections['cart-drawer-section'];
              var nuevo = env.querySelector('#shopify-section-cart-drawer-section');
              if (nuevo) destino.replaceWith(nuevo);
            }
          }
          document.dispatchEvent(new CustomEvent('shopify:cart:lines-update', {
            bubbles: true,
            detail: { source: 'strapion-pack-cruzado', action: 'add' }
          }));

          /* Mismo gesto que el boton principal: sin abrir el cajon el cliente
             no ve que haya pasado nada y vuelve a pulsar. */
          abrirCajon();
          avisar('Added both', 'ok');
        })
        .catch(function (error) {
          avisar(error.message || 'Could not add to cart', 'error');
        })
        .then(function () {
          el.add.classList.remove('is-cargando');
        });
    });

    /* El configurador avisa en cada repintado y el evento sube por el DOM. */
    document.addEventListener('strapion:variante', pintar);
    pintar();
  }

  /* --- "You may also like" ------------------------------------------------
     Shopify ordena esas recomendaciones por popularidad y no mira el stock por
     variante. El resultado medido en la ficha de cuero: de las cuatro, TRES no
     tienen ni Whoop 5 Black ni Silver —las dos monturas que lleva casi todo el
     mundo— y la que abria el bloque era Green Camo, que solo conserva Gold y
     Rose Gold. Es logico que pase: popular acaba siendo agotado.

     Por eso se REORDENA en vez de esconder. Filtrar por "tiene Black o Silver"
     habria dejado una sola tarjeta de cuatro, y una rejilla con un hueco es
     peor que una recomendacion floja. Solo se esconde lo que no tiene
     literalmente nada en la montura elegida.

     El orden es: primero las que tienen Black o Silver, despues por cuantas
     monturas vivas les quedan, y a igualdad manda el orden de Shopify. Asi el
     bloque abre siempre con algo que el visitante puede comprar.

     Falla abierto: si no se sabe el stock de una tarjeta se deja donde estaba
     y visible. */
  var fichaCache = {};
  var reordenando = false;

  function datosDelPack() {
    var bloque = document.querySelector('[data-sx-cruzado-datos]');
    if (!bloque) return {};
    try {
      return (JSON.parse(bloque.textContent) || {}).productos || {};
    } catch (e) {
      return {};
    }
  }

  function variantesDe(handle) {
    if (fichaCache[handle]) return Promise.resolve(fichaCache[handle]);
    return fetch('/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d) return null;
        /* Se normaliza al molde que emite Liquid para el bundle: la montura es
           el valor de la opcion "Frame", no el titulo entero de la variante. */
        var iFrame = -1;
        (d.options || []).forEach(function (o, n) {
          var nombre = (o && o.name ? o.name : o) + '';
          if (nombre.toLowerCase() === 'frame') iFrame = n;
        });
        var v = d.variants.map(function (x) {
          return {
            disponible: x.available,
            frame: iFrame >= 0 ? x.options[iFrame] : x.title
          };
        });
        fichaCache[handle] = v;
        return v;
      })
      .catch(function () { return null; });
  }

  /* Monturas vivas que encajan, y si entre ellas hay alguna de las comunes.
     Black y Silver van aparte y no como simple recuento porque no valen lo
     mismo: una correa que solo existe en dorado es, para la mayoria, una
     correa que no existe. */
  function surtido(variantes, montura) {
    if (!variantes) return null;
    var vivas = 0;
    var comun = false;
    variantes.forEach(function (v) {
      if (!v.disponible || !encaja(v.frame, montura)) return;
      vivas++;
      if (/\b(Black|Silver)$/.test(v.frame)) comun = true;
    });
    return { vivas: vivas, comun: comun };
  }

  function filtrarRecomendaciones() {
    if (reordenando) return;
    var zona = document.querySelector('product-recommendations');
    if (!zona) return;
    var tarjetas = Array.prototype.slice.call(zona.querySelectorAll('product-card'));
    if (!tarjetas.length) return;

    var montura = monturaActual();
    if (!montura) return;

    var productos = datosDelPack();
    var pendientes = tarjetas.map(function (t, orden) {
      var enlace = t.querySelector('a[href*="/products/"]');
      if (!enlace) return Promise.resolve(null);
      var handle = enlace.pathname.split('/').pop();
      var delPack = productos[handle];
      var promesa = delPack
        ? Promise.resolve(delPack.variantes)
        : variantesDe(handle);
      return promesa.then(function (v) {
        return { nodo: t, orden: orden, s: surtido(v, montura) };
      });
    });

    Promise.all(pendientes).then(function (lista) {
      lista = lista.filter(Boolean);
      if (!lista.length) return;

      var conAlgo = lista.filter(function (x) { return !x.s || x.s.vivas > 0; });

      /* Con menos de dos supervivientes se esconde la seccion entera. Pasa de
         verdad: con la montura "MG Gold" solo una de las cuatro tiene algo que
         vender. Una tarjeta suelta en una rejilla de dos columnas parece un
         error de maquetacion, y el bundle de arriba ya ofrece esa correa. Las
         que no se han podido consultar cuentan como supervivientes, asi que
         llegar aqui significa que se SABE que no hay nada. */
      var seccion = zona.closest('.shopify-section') || zona;
      seccion.classList.toggle('sx-recom-vacia', conAlgo.length < 2);
      if (conAlgo.length < 2) return;

      lista.forEach(function (x) {
        var muerta = x.s && x.s.vivas === 0;
        var caja = x.nodo.closest('.resource-list__item') || x.nodo;
        caja.classList.toggle('sx-recom-oculta', !!muerta);
      });

      var ordenadas = conAlgo.slice().sort(function (a, b) {
        var ca = a.s && a.s.comun ? 1 : 0;
        var cb = b.s && b.s.comun ? 1 : 0;
        if (ca !== cb) return cb - ca;
        var va = a.s ? a.s.vivas : 0;
        var vb = b.s ? b.s.vivas : 0;
        if (va !== vb) return vb - va;
        return a.orden - b.orden;
      });

      var cambia = ordenadas.some(function (x, n) { return x.orden !== conAlgo[n].orden; });
      if (!cambia) return;

      /* Se mueve el envoltorio de la rejilla, no la tarjeta: el tema apoya el
         hueco de la celda en `.resource-list__item`. Y se marca `reordenando`
         porque el propio movimiento dispara el MutationObserver y sin la
         guarda se llamaria a si mismo sin parar. */
      reordenando = true;
      var primera = ordenadas[0].nodo.closest('.resource-list__item') || ordenadas[0].nodo;
      var rejilla = primera.parentElement;
      ordenadas.forEach(function (x) {
        rejilla.appendChild(x.nodo.closest('.resource-list__item') || x.nodo);
      });
      window.setTimeout(function () { reordenando = false; }, 0);
    });
  }

  function vigilarRecomendaciones() {
    var seccion = document.querySelector('product-recommendations');
    if (!seccion) return;
    /* La seccion se rellena por la Section Rendering API cuando entra en
       pantalla, asi que no basta con ordenarla una vez al cargar. */
    new MutationObserver(filtrarRecomendaciones).observe(seccion, {
      childList: true,
      subtree: true
    });
    document.addEventListener('strapion:variante', filtrarRecomendaciones);
    filtrarRecomendaciones();
  }

  function arrancar() {
    var cajas = document.querySelectorAll('[data-sx-cruzado]');
    Array.prototype.forEach.call(cajas, iniciar);
    vigilarRecomendaciones();
  }


  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
})();


/* === Constructor de packs de la pagina del anuncio =======================
   Un bloque donde el visitante monta el pack antes de elegir producto.

   Por que, con los numeros de la tienda por pedido (ya descontados coste,
   envio, comision y pauta):

       1 nylon            -6,93 EUR
       2 nylon            +2,85 EUR
       3 nylon           +11,62 EUR
       1 nylon + 1 cuero +13,33 EUR

   El pedido de una sola correa pierde dinero y dos de cada cinco pedidos lo
   eran. Este bloque existe para que el primer gesto de la pagina sea elegir
   una combinacion, no una unidad.

   LOS DOS EJES. La opcion "Frame" del catalogo mezcla dos decisiones que no
   se parecen en nada:

     - La familia (WHOOP 5.0 o MG) es COMPATIBILIDAD. Es el reloj que tienes
       y no cambia entre las correas de un mismo pedido. Va arriba, una vez.
     - El cierre (Black, Silver, Gold, Rose Gold) es ESTETICA. Y cambia: los
       dos pedidos de tres unidades de la tienda mezclaron cierres, los dos.
       Va en cada correa.

   Con un solo selector compartido, el pack impedia comprar exactamente lo
   que esos dos clientes compraron.

   Lo que NO se puede: mezclar WHOOP 5.0 con MG en el mismo pack. Solo le
   sirve a quien tenga dos relojes, y soportarlo obligaria a 8 chips por
   hueco, o sea dos filas por correa en una pantalla de 375 px.

   Otras decisiones que conviene entender:

   - Los colores van en tiras dentro de la tarjeta, sin ventanas. A 375 px
     una modal por hueco vuelve el bloque inservible.
   - Las fotos van lado a lado con el "+" y las tiras debajo a ancho
     completo: dentro del hueco solo cabian 4 muestras de 28.
   - No hay productos "pack" en Shopify. Un pack es meter dos o tres
     variantes en el carrito y dejar que el descuento automatico haga el
     resto. Crear SKUs de pack habria roto ese descuento y el inventario. */
(function () {
  'use strict';

  var SELECTOR_CAJON_PACKS = '[on\\:click="#cart-drawer/toggle"]';

  /* Espejo de los descuentos automaticos de la tienda. Si cambian en el panel
     de Shopify hay que cambiarlos aqui: el bloque los ANUNCIA, no los aplica. */
  var TRAMOS = { 2: 10, 3: 15 };

  /* Para mostrar: negro y plata primero, que son los relojes mas comunes. */
  var ORDEN_CIERRE = ['Black', 'Silver', 'Gold', 'Rose Gold'];

  /* Para reconocer el sufijo: "Rose Gold" ANTES que "Gold", o "MG Rose Gold"
     se partiria como familia "MG Rose" + cierre "Gold". */
  var CIERRES = ['Rose Gold', 'Black', 'Silver', 'Gold'];

  function dinero(c) { return '$' + (c / 100).toFixed(2); }

  /* "Whoop 5 Black" -> familia "Whoop 5", cierre "Black".
     "Whoop 5"       -> familia "Whoop 5", cierre null (asi viene el cuero,
                        que lleva su propia hebilla y no ofrece acabados). */
  function partirFrame(f) {
    if (!f) return { familia: null, cierre: null };
    for (var i = 0; i < CIERRES.length; i++) {
      var c = CIERRES[i];
      if (f.length > c.length + 1 && f.slice(-(c.length + 1)) === ' ' + c) {
        return { familia: f.slice(0, f.length - c.length - 1), cierre: c };
      }
    }
    return { familia: f, cierre: null };
  }

  function nombreFamilia(f) {
    return f === 'Whoop 5' ? 'WHOOP 5.0' : f;
  }

  /* Variante vendible de una opcion para esa familia. Se prefiere el cierre
     pedido; si no lo hay, cualquiera de la familia, que es mejor que dejar el
     hueco vacio por un acabado. El cuero entra por la rama de cierre null. */
  function varianteDe(op, familia, cierre) {
    var suelto = null;
    for (var i = 0; i < op.vars.length; i++) {
      var v = op.vars[i];
      if (!v.d) continue;
      var pf = partirFrame(v.f);
      if (pf.familia !== familia) continue;
      if (pf.cierre === null) return v;
      if (cierre && pf.cierre === cierre) return v;
      if (!suelto) suelto = v;
    }
    return suelto;
  }

  function cierresDe(op, familia) {
    var vistos = {};
    var fuera = [];
    op.vars.forEach(function (v) {
      if (!v.d) return;
      var pf = partirFrame(v.f);
      if (pf.familia !== familia || pf.cierre === null) return;
      if (vistos[pf.cierre]) return;
      vistos[pf.cierre] = true;
      fuera.push(pf.cierre);
    });
    fuera.sort(function (a, b) {
      return ORDEN_CIERRE.indexOf(a) - ORDEN_CIERRE.indexOf(b);
    });
    return fuera;
  }

  function iniciar(caja) {
    if (caja.sxPacksListo) return;
    caja.sxPacksListo = true;

    var bloque = caja.querySelector('[data-sx-packs-datos]');
    if (!bloque) return;
    var datos;
    try { datos = JSON.parse(bloque.textContent); } catch (e) { return; }

    var pools = datos.pools || {};
    var packs = (datos.packs || []).filter(function (p) {
      return (p.huecos || []).every(function (h) { return (pools[h] || []).length; });
    });
    if (!packs.length) return;

    var elFamilias = caja.querySelector('[data-sx-packs-monturas]');
    var elLista = caja.querySelector('[data-sx-packs-lista]');
    var elAviso = caja.querySelector('[data-sx-packs-feedback]');

    /* Las familias salen del catalogo, no escritas a mano: si manana se
       descataloga una entera, desaparece sola del selector. */
    var familias = [];
    Object.keys(pools).forEach(function (k) {
      pools[k].forEach(function (o) {
        o.vars.forEach(function (v) {
          if (!v.d) return;
          var fa = partirFrame(v.f).familia;
          if (fa && familias.indexOf(fa) < 0) familias.push(fa);
        });
      });
    });
    familias.sort(function (a, b) { return (a === 'MG' ? 1 : 0) - (b === 'MG' ? 1 : 0); });
    if (!familias.length) return;

    var estado = { familia: familias[0], color: {}, cierre: {} };
    packs.forEach(function (pack, ip) {
      /* Cada hueco arranca en un color distinto: con todos a cero, el pack de
         dos nylon salia "Yellow + Yellow", que parece un error de la tienda. */
      estado.color[ip] = pack.huecos.map(function (nombrePool, ih) {
        var usados = 0;
        for (var k = 0; k < ih; k++) {
          if (pack.huecos[k] === nombrePool) usados++;
        }
        return usados;
      });
      estado.cierre[ip] = pack.huecos.map(function () { return null; });
    });

    function opcionesVivas(nombrePool) {
      return (pools[nombrePool] || []).filter(function (o) {
        return varianteDe(o, estado.familia, null);
      });
    }

    function pintarFamilias() {
      elFamilias.innerHTML = '';
      familias.forEach(function (f) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'sc-packs__chip' + (f === estado.familia ? ' is-activo' : '');
        b.setAttribute('role', 'radio');
        b.setAttribute('aria-checked', f === estado.familia ? 'true' : 'false');
        b.textContent = nombreFamilia(f);
        b.addEventListener('click', function () {
          estado.familia = f;
          pintar();
        });
        elFamilias.appendChild(b);
      });
    }

    function pintarPack(pack, ip) {
      var art = document.createElement('article');
      art.className = 'sc-combo';

      var pct = TRAMOS[pack.huecos.length] || 0;
      var cab = document.createElement('div');
      cab.className = 'sc-combo__cab';
      cab.innerHTML = '<h3></h3>' + (pct ? '<span class="sc-combo__off">-' + pct + '%</span>' : '');
      cab.querySelector('h3').textContent = pack.nombre;
      art.appendChild(cab);

      var fila = document.createElement('div');
      fila.className = 'sc-combo__huecos';
      art.appendChild(fila);

      var tiras = document.createElement('div');
      tiras.className = 'sc-combo__tiras';
      art.appendChild(tiras);

      var bruto = 0;
      var faltan = false;
      var lineas = [];

      pack.huecos.forEach(function (nombrePool, ih) {
        if (ih > 0) {
          var mas = document.createElement('span');
          mas.className = 'sc-combo__mas';
          mas.setAttribute('aria-hidden', 'true');
          mas.textContent = '+';
          fila.appendChild(mas);
        }

        var vivas = opcionesVivas(nombrePool);
        var hueco = document.createElement('div');
        hueco.className = 'sc-combo__hueco';

        if (!vivas.length) {
          faltan = true;
          hueco.innerHTML = '<p class="sc-combo__sinstock">Not available for this WHOOP</p>';
          fila.appendChild(hueco);
          return;
        }

        var idx = estado.color[ip][ih];
        if (idx >= vivas.length) { idx = 0; estado.color[ip][ih] = 0; }
        var op = vivas[idx];

        var cierres = cierresDe(op, estado.familia);
        var cierre = estado.cierre[ip][ih];
        if (cierres.length && cierres.indexOf(cierre) < 0) {
          cierre = cierres[0];
          estado.cierre[ip][ih] = cierre;
        }

        var v = varianteDe(op, estado.familia, cierre);
        bruto += v.p;
        lineas.push({ id: v.id, quantity: 1 });

        var img = document.createElement('img');
        img.className = 'sc-combo__foto';
        img.src = op.foto || '';
        img.alt = op.n;
        img.width = 120; img.height = 120; img.loading = 'lazy';
        hueco.appendChild(img);
        fila.appendChild(hueco);

        var grupo = document.createElement('div');
        grupo.className = 'sc-combo__grupo';

        var etiqueta = document.createElement('span');
        etiqueta.className = 'sc-combo__tira-label';
        etiqueta.textContent = op.sub ? op.sub + ' · ' + op.n : op.n;
        grupo.appendChild(etiqueta);

        var tira = document.createElement('div');
        tira.className = 'sc-combo__tira';
        vivas.forEach(function (o, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'sc-combo__muestra' + (i === idx ? ' is-activo' : '');
          b.title = o.sub ? o.sub + ' ' + o.n : o.n;
          b.setAttribute('aria-label', b.title);
          b.setAttribute('aria-pressed', i === idx ? 'true' : 'false');
          if (o.color) {
            b.innerHTML = '<span style="background:' + o.color + '"></span>';
          } else {
            var mini = document.createElement('img');
            mini.src = o.foto || '';
            mini.alt = '';
            mini.loading = 'lazy';
            b.appendChild(mini);
          }
          b.addEventListener('click', function () {
            estado.color[ip][ih] = i;
            pintar();
          });
          tira.appendChild(b);
        });
        grupo.appendChild(tira);

        /* El acabado del cierre, solo donde existe: el cuero no lo ofrece
           porque lleva hebilla propia, y con una sola opcion la fila sobra. */
        if (cierres.length > 1) {
          var fc = document.createElement('div');
          fc.className = 'sc-combo__cierres';
          cierres.forEach(function (c) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'sc-combo__cierre' + (c === cierre ? ' is-activo' : '');
            b.setAttribute('aria-pressed', c === cierre ? 'true' : 'false');
            b.textContent = c;
            b.addEventListener('click', function () {
              estado.cierre[ip][ih] = c;
              pintar();
            });
            fc.appendChild(b);
          });
          grupo.appendChild(fc);
        }

        tiras.appendChild(grupo);
      });

      var neto = bruto - Math.round((bruto * pct) / 100);

      var pie = document.createElement('div');
      pie.className = 'sc-combo__pie';
      pie.innerHTML =
        '<span class="sc-combo__total">' +
          (pct ? '<s>' + dinero(bruto) + '</s>' : '') +
          '<strong>' + dinero(neto) + '</strong>' +
        '</span>' +
        '<button type="button" class="sc-combo__add"></button>';
      var boton = pie.querySelector('.sc-combo__add');
      boton.textContent = faltan ? 'Not available' : 'Add pack to cart';
      boton.disabled = faltan;
      if (!faltan) {
        boton.addEventListener('click', function () { anadir(boton, lineas, pack.nombre); });
      }
      art.appendChild(pie);

      return art;
    }

    function pintar() {
      pintarFamilias();
      elLista.innerHTML = '';
      packs.forEach(function (pack, ip) {
        elLista.appendChild(pintarPack(pack, ip));
      });
      caja.hidden = false;
    }

    function avisar(texto, tipo) {
      elAviso.textContent = texto;
      elAviso.className = 'sc-packs__feedback is-visible' + (tipo ? ' sc-packs__feedback--' + tipo : '');
      window.setTimeout(function () {
        elAviso.className = 'sc-packs__feedback';
        elAviso.textContent = '';
      }, 6000);
    }

    function abrirCajon() {
      var cajon = document.querySelector('theme-drawer#cart-drawer');
      if (cajon && typeof cajon.open === 'function') { cajon.open(); return; }
      var disp = document.querySelector(SELECTOR_CAJON_PACKS);
      if (disp) disp.click();
    }

    function anadir(boton, lineas, nombre) {
      if (boton.classList.contains('is-cargando')) return;
      boton.classList.add('is-cargando');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: lineas, sections: 'cart-drawer-section' })
      })
        .then(function (r) {
          return r.json().then(function (cuerpo) {
            if (!r.ok) throw new Error(cuerpo.description || cuerpo.message || 'Could not add to cart');
            return cuerpo;
          });
        })
        .then(function (cuerpo) {
          if (cuerpo.sections && cuerpo.sections['cart-drawer-section']) {
            var destino = document.getElementById('shopify-section-cart-drawer-section');
            if (destino) {
              var env = document.createElement('div');
              env.innerHTML = cuerpo.sections['cart-drawer-section'];
              var nuevo = env.querySelector('#shopify-section-cart-drawer-section');
              if (nuevo) destino.replaceWith(nuevo);
            }
          }
          document.dispatchEvent(new CustomEvent('shopify:cart:lines-update', {
            bubbles: true, detail: { source: 'strapion-packs', action: 'add' }
          }));
          abrirCajon();
          avisar('Added — ' + nombre, 'ok');
        })
        .catch(function (error) {
          avisar(error.message || 'Could not add to cart', 'error');
        })
        .then(function () {
          boton.classList.remove('is-cargando');
        });
    }

    pintar();
  }

  function arrancar() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-sx-packs]'), iniciar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
})();
